import { render, staticRenderFns } from "./CustomsBroker.vue?vue&type=template&id=80d5c75c&scoped=true&lang=pug&"
import script from "./CustomsBroker.vue?vue&type=script&lang=coffee&"
export * from "./CustomsBroker.vue?vue&type=script&lang=coffee&"
import style0 from "./CustomsBroker.vue?vue&type=style&index=0&id=80d5c75c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d5c75c",
  null
  
)

export default component.exports